import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import MetricsService from 'cio/services/metrics';
import BaseOverviewIndexController from 'cio/pods/base/overview/index/controller';
import Transition from '@ember/routing/-private/transition';
import CampaignModel from 'cio/models/campaign';
import DS from 'ember-data';

export default class OverviewIndexRoute extends Route {
  templateName = 'base/overview/index';

  @service('metrics') metricsService!: MetricsService;
  @service store!: DS.Store;

  afterModel() {
    return this.store.findAll('short-segment');
  }

  setupController(controller: BaseOverviewIndexController, model: CampaignModel, transition: Transition) {
    super.setupController(controller, model, transition);

    controller.limitEndTime();
    controller.deserializeQueryParams();
    controller.setAllAvailableChannels();
  }

  resetController(controller: BaseOverviewIndexController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.resetQueryParams();
    }
  }
}
